import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { JournalHomeComponent } from '../journal/journal-home/journal-home.component';

const homeRoutes: Routes = [
	{
		path: '',
		component: JournalHomeComponent
	},
	{
		path: 'home',
		component:JournalHomeComponent
	},
	
	
	{ path: '**', redirectTo: 'page-not-found/404', pathMatch: 'full' },

]

@NgModule({
	imports: [RouterModule.forChild(homeRoutes)],
	exports: [RouterModule]
})
export class HomeRoutingModule { }
